import { gql } from "@apollo/client";

import { MEMBER_INFO } from "../fragments";

export const RESEND_OTP = gql`
  mutation resendEmailOtp {
    resendEmailOtp
  }
`;

export const VERIFY_EMAIL = gql`
  mutation verifyEmail($code: String!) {
    verifyEmail(code: $code) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const UPDATE_PERSONAL_DATA = gql`
  mutation updatePersonalData($input: PersaonalDataInput!) {
    updatePersonalData(input: $input) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const UPLOAD_IDENTITY = gql`
  mutation uploadIdentityDoc($input: IdentityDocInput!) {
    uploadIdentityDoc(input: $input) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const UPDATE_ACCOUNT = gql`
  mutation updateAccount($input: AccountInput!) {
    updateAccount(input: $input) {
      id
    }
  }
`;

export const UPDATE_LOGIN_PASSWORD = gql`
  mutation updatePassword($input: PasswordInput!) {
    updatePassword(input: $input) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const UPDATE_WITHDRAW_PASSWORD = gql`
  mutation updateWithdrawPassword($input: PasswordInput!) {
    updateWithdrawPassword(input: $input) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;

export const UPLOAD_PROFILE_IMAGE = gql`
  mutation uploadProfile($imageFile: Upload!) {
    uploadProfile(imageFile: $imageFile) {
      ...memberInfo
    }
  }
  ${MEMBER_INFO}
`;
